import type * as Types from '../../types/graphql';

export type VariantTemplateSelectFragment = Pick<Types.VariantTemplate, 'id' | 'redirectURL'>;

export type VariantSelectFragment = Pick<
  Types.Variant,
  'id' | 'isOrigin' | 'templateSuffix' | 'templateType' | 'themePageID'
>;

export type VariantWithTemplateSelectFragment = Pick<
  Types.Variant,
  'id' | 'isOrigin' | 'templateSuffix' | 'templateType' | 'themePageID'
> & { template?: Types.Maybe<Pick<Types.VariantTemplate, 'id' | 'redirectURL'>> };

export type VariantCampaignSelectFragment = Pick<
  Types.Variant,
  'id' | 'isOrigin' | 'templateSuffix' | 'templateType' | 'themePageID'
> & {
  campaign?: Types.Maybe<
    Pick<Types.Campaign, 'id' | 'name' | 'status' | 'type'> & {
      group?: Types.Maybe<Pick<Types.CampaignGroup, 'id' | 'title' | 'status' | 'type'>>;
    }
  >;
};

export const VariantSelectFragmentDoc = `
    fragment VariantSelect on Variant {
  id
  isOrigin
  templateSuffix
  templateType
  themePageID
}
    `;
export const VariantTemplateSelectFragmentDoc = `
    fragment VariantTemplateSelect on VariantTemplate {
  id
  redirectURL
}
    `;
export const VariantWithTemplateSelectFragmentDoc = `
    fragment VariantWithTemplateSelect on Variant {
  ...VariantSelect
  template {
    ...VariantTemplateSelect
  }
}
    `;
export const VariantCampaignSelectFragmentDoc = `
    fragment VariantCampaignSelect on Variant {
  ...VariantSelect
  campaign {
    ...CampaignSelect
  }
}
    `;
